import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { formatReservationTime } from '../utils/activityReservations'

/**
 * Asked when an activity is cancelled or deleted and it still holds court bookings.
 * Only bookings this feature created are offered for release: ones merely attached
 * belong to whoever made them, and are left alone.
 */
function ActivityReservationReleaseDialog({ open, reservations, onKeep, onRelease, onCancel, working }) {
  const rows = reservations || []

  return (
    <Dialog open={open} onClose={onCancel} maxWidth='sm' fullWidth>
      <DialogTitle>Vapautetaanko varaukset?</DialogTitle>
      <DialogContent>
        <Typography variant='body1' gutterBottom>
          {rows.length === 1
            ? 'Aktiviteetilla on yksi tästä luotu varaus:'
            : 'Aktiviteetilla on ' + rows.length + ' tästä luotua varausta:'}
        </Typography>
        {rows.map((reservation) => (
          <Typography key={reservation.id} variant='body2' sx={{ mb: 0.5 }}>
            <b>{reservation.resourcename || reservation.resourceid}</b> — {formatReservationTime(reservation)}
          </Typography>
        ))}
        <Typography variant='body2' color='text.secondary' sx={{ mt: 2 }}>
          Vapauttaminen peruu varaukset ja vapauttaa vuorot kalenterissa. Säilyttäminen jättää ne
          voimaan, jolloin vuorot pysyvät varattuina.
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          Muualla tehdyt, aktiviteettiin vain liitetyt varaukset jäävät aina koskematta.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={working}>
          Peruuta
        </Button>
        <Button onClick={onKeep} disabled={working}>
          Säilytä varaukset
        </Button>
        <Button onClick={onRelease} variant='contained' color='error' disabled={working}>
          {working ? 'Vapautetaan...' : 'Vapauta varaukset'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ActivityReservationReleaseDialog
